class MFRBlogGrid {
  constructor(i, e) {
    this.$index = i;
    this.$element = $(e);

    this.selectors = {
      entries: ".blog-grid__grid-entries",
      loadMoreButton: ".blog-grid__load-more",
      entry: ".blog-grid__grid-entry",
      footer: ".blog-grid__grid-footer",
      link: ".blog-grid__filters-inner li a",
      blogCard: ".blog-card",
      filtersWrapper: ".blog-grid__filters-inner",
    };

    this.init();
  }

  init() {
    this.$entries = this.$element.find(this.selectors.entries);
    this.$loadMoreButton = this.$element.find(this.selectors.loadMoreButton);
    this.entriesID = this.$entries.attr("id");
    this.$footer = this.$element.find(this.selectors.footer);
    this.$filters = this.$element.find(this.selectors.link);
    this.$filtersWrapper = this.$element.find(this.selectors.filtersWrapper);
    this.initBlogGrid();
  }

  initBlogGrid() {
    this.$loadMoreButton.on("click", this.__handleLoadMore.bind(this));
    this.$filters.on("click", this.__handleFilterClick.bind(this));

    this.setInitialActiveFilter();
    $(window).on("popstate", this.setInitialActiveFilter.bind(this));
  }

  __handleFilterClick(e) {
    if (!$(e.currentTarget).data("filter").length) return;
    this.setActiveFilter(e.currentTarget);
    this.setFilterUrl($(e.currentTarget).data("filter"));
    this.setNewSource($(e.currentTarget).data("filter"));
  }

  __handleLoadMore(e) {
    const allPages = this.$entries.data("all-pages");
    const blogUrl = window.location.pathname;
    const currentPage = this.$entries.data("current-page");
    const currentPageNew = currentPage + 1;
    const nextLinkNumber = currentPage + 2;
    const nextLink = `${blogUrl}?page=${currentPageNew}`;
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });
    const hasView = params.view ? `&${params.view}` : "";

    this.$footer.addClass("is-loading");

    $.ajax({
      url: nextLink,
      type: "GET",
      dataType: "html",
      success: (responseHTML) => {
        const newBlogsWrapper = $(responseHTML).find(`#${this.entriesID}`);

        // append newer blogs
        this.$entries.append(newBlogsWrapper.html());
        if (ScrollTrigger && ScrollTrigger.refresh) ScrollTrigger.refresh();

        //update entries data
        this.$entries.data(
          "next-link",
          `${blogUrl}?page=${nextLinkNumber}${hasView}`
        );
        this.$entries.data("current-page", currentPageNew);

        //update url parameter
        this.addQueryParam("page", this.$entries.data("current-page"));
      },
      complete: () => {
        if (currentPageNew < allPages) {
          // there's still some blogs to pull
          this.$footer.removeClass("is-loading");
        } else {
          // there's no blog to pull
          this.$footer.removeClass("is-loading").addClass("no-more");
        }
      },
    });
  }

  addQueryParam(name, value) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.set(name, value);
    const newUrl = window.location.pathname + "?" + urlParams.toString();
    window.history.pushState({ path: newUrl }, "", newUrl);
  }

  setInitialActiveFilter() {
    this.$filters.removeClass("is-active");
    if (window.location.pathname.includes("tagged")) {
      const activeTags = this.getActiveTags();
      this.$element.find(this.selectors.link).each((i, e) => {
        const filters = $(e).data("filter");
        if (typeof filters == "object") {
          const matchedFilter = filters.filter((e, i) =>
            activeTags.includes(e)
          );
          if (matchedFilter.length) {
            $(e).addClass("is-active");
          }
        }
      });
    } else {
      this.$element
        .find(this.selectors.link + "[data-filter='*']")
        .addClass("is-active");
    }
  }

  getActiveTags() {
    return window.location.pathname.split("/tagged/")[1].split(",");
  }

  setActiveFilter(current) {
    this.$filters.removeClass("is-active");
    $(current).addClass("is-active");
  }

  setFilterUrl(filters) {
    const baseUrl = this.$element.find(this.selectors.entries).data("blog-url");
    window.history.pushState(
      null,
      "",
      filters == "*" ? baseUrl : `${baseUrl}/tagged/${filters.join(",")}`
    );
  }

  setNewSource( filters ) {
    const baseUrl = this.$element.find(this.selectors.entries).data("blog-url");
    const filterUrl =
      filters == "*" ? baseUrl : `${baseUrl}/tagged/${filters.join(",")}`;

    this.$footer.addClass("is-loading");
    this.$filtersWrapper.addClass("is-loading");
    // this.$element.find( this.selectors.blogCard ).fadeOut( (i,e) => $( e ).remove() );
    gsap.to(this.$element.find(this.selectors.blogCard), {
      opacity: 0,
      ease: "back.in",
      onComplete: (e) => {
        this.$element.find(this.selectors.blogCard).remove();
        if (ScrollTrigger && ScrollTrigger.refresh) ScrollTrigger.refresh();
        $.ajax({
          url: filterUrl,
          type: "GET",
          dataType: "html",
          success: (responseHTML) => {
            const newBlogsWrapper = $(responseHTML).find(`#${this.entriesID}`);

            // append newer blogs
            this.$entries.append(newBlogsWrapper.html());
            gsap.fromTo(
              this.$entries.find(this.selectors.blogCard),
              {
                opacity: 0,
              },
              {
                opacity: 1,
                ease: "back",
              }
            );
            if (ScrollTrigger && ScrollTrigger.refresh) ScrollTrigger.refresh();

            this.$entries.data("all-pages", newBlogsWrapper.data("all-pages"));
            this.$entries.data("current-page", 1);
          },
          complete: (e) => {
            if (e.status == 404) {
              this.$footer.removeClass("is-loading").addClass("no-more");
            } else {
              this.$footer.removeClass("is-loading").removeClass("no-more");
            }
            this.$filtersWrapper.removeClass("is-loading");
          },
        });
      },
    });

    // const allPages = this.$entries.data("all-pages");
    // const blogUrl = window.location.pathname;
    // const currentPage = this.$entries.data("current-page");
    // const currentPageNew = currentPage + 1;
    // const nextLinkNumber = currentPage + 2;
    // const nextLink = `${blogUrl}?page=${currentPageNew}`;
  }
}